import React, { Component } from 'react';
import auth from '../modules/Auth0_setup';
import {Redirect} from 'react-router-dom';
import SubscriptionPage from './subscription-container';
import {wrappedWithStripe} from "./tabbed_content";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {startFetchingSubscriptionList} from "../actions/getSubscriptions";

class PlanSelectionPage extends Component {
    componentWillMount() {
        this.props.startFetchingSubscriptionList();
    }

    render() {
        if (!auth.isAuthenticated())
            return <Redirect to='/login'/>;

        return (
            wrappedWithStripe(<SubscriptionPage/>)
        )
    }
}


/**
 * Redux connection
 */
const mapStateToProps = state => ({
    userProfile: state.userProfile.profile,
    ...state.subscriptions
})
const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        startFetchingSubscriptionList
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanSelectionPage);


// WEBPACK FOOTER //
// ./src/containers/plan-selection.js